<template>
  <div class="document-loader">
    <label>
      <input type="file" accept="image/*" :ref="'docInput_' + randomRef" @change="setFile(), previewMultiImage($event)" multiple class="file-loader-input">
      <span class="btn accent-btn">Загрузить документ</span>
    </label>
    <!-- <label>
      <input type="file" @change="onFileChange($event.target.name, $event.target.files)" multiple class="file-loader-input">
      <span class="btn accent-btn">Загрузить тест</span>
    </label> -->
    <div v-if="showDocsList !== false">
      <div class="file-item" v-for="(file, index) in files" :key="index">
        <div class="file-info">
          <div v-if="showImage === true" class="file-preview" :style="{ 'background-image': 'url(' + preview_list[index] + ')'}"></div>
          <p>{{ file.name }}</p>
        </div>
        <img class="close-img" src="@img/close.svg" alt="" @click="deleteDoc(index)">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'document-loader',
  props: ['showDocsList', 'initData', 'deleteItemIndex', 'showImage'],
  data () {
    return {
      files: [],
      randomRef: '_',
      photoFiles: [],
      preview_list: [],
      image_list: []
    }
  },
  created () {
    this.randomRef = (100 + Math.floor(500 * Math.random()))
  },
  watch: {
    deleteItemIndex (newVal) {
      if (newVal !== undefined && newVal !== null && newVal !== -1) {
        this.deleteDoc(newVal)
      }
    },
    initData (newVal) {
      if (newVal !== undefined && newVal !== null && newVal.length > 0) {
        let fileList = []
        newVal.forEach(file => {
          fileList.push({
            file: file.file,
            name: (file.name !== null) ? file.name : 'нет имени файла',
            uploadByUser: false
          })
        })
        this.setFile(fileList)
        this.files.forEach(file => {
          this.preview_list.push(this.getMinioFileUrlMix('photo', file.file))
        })
        this.$emit('setDocWidthType', fileList)
      }
    }
  },
  methods: {
    previewMultiImage (event) {
      var input = event.target
      var count = input.files.length
      var index = 0
      if (input.files) {
        while (count--) {
          var reader = new FileReader()
          reader.onload = (e) => {
            this.preview_list.push(e.target.result)
          }
          this.image_list.push(input.files[index])
          reader.readAsDataURL(input.files[index])
          index++
        }
      }
    },
    deleteDoc (index) {
      this.files.splice(index, 1)
      this.preview_list.splice(index, 1)
    },
    setFile (files) {
      let _fileList = []
      if (files === undefined) {
        _fileList = this.$refs['docInput_' + this.randomRef].files
      } else {
        _fileList = files
      }
      this.files = [...this.files, ..._fileList]
      this.$emit('changeFileList', this.files)
    }
  }
}
</script>

<style lang="scss" scoped>
.file-preview {
  flex: none;
  margin-right: 10px;
  width: 60px;
  height: 60px;
  border-radius: 8px;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-size: cover;
  box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.08);
}
.document-loader {
  span {
    display: inline-block;
    cursor: pointer;
    padding: 7px 12px;
    font-size: 12px;
  }
  .file-item {
    margin-top: 10px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .close-img {
      cursor: pointer;
    }
    p {
      margin-bottom: 0;
    }
  }
  .file-info {
    display: flex;
    align-items: center;
  }
}
.file-loader-input {
  width: 0;
  height: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/FileLoader.vue